import {region} from '../../../shared/regions.mjs';
import type {OnlinePlayer} from '../net/online';
export function atlasTravelReason(me:OnlinePlayer|undefined,city:string):string|null{
 if(!me)return 'เชื่อมต่อเซิร์ฟเวอร์ก่อน';
 if((me.hp??120)<=0)return 'ต้องมีชีวิตอยู่';
 if(!region(me.mapId??'')?.safe)return 'ออกจากเขตต่อสู้ก่อน';
 if((me.height??0)>5)return 'ยืนบนพื้นก่อนเดินทาง';
 if(me.mapId===city)return 'อยู่เมืองนี้แล้ว';
 if(!me.journey?.discovered.includes(city))return 'เดินไปค้นพบเมืองนี้ก่อน';
 if(city==='laplae-town'&&!me.journey?.laplaeOath)return 'ผ่านคำสัตย์แห่งลับแลก่อน';
 if((me.inventory?.['warp-talisman']??0)<1)return 'ต้องมียันต์วาร์ป 1 ชิ้น';
 return null;
}
